module.exports = __webpack_public_path__ + "media/images/front/premium_lp/btn_free_01-fc7c8b321fc50ec40b668c2c60ea1c34.png";